import { RequirePermission } from '@/components/auth/RequirePermission';
import { AppLayout } from '@/components/layout/AppLayout';
import NotFound from '@/pages/NotFound';
import { appRoutes, publicRoutes } from '@/routes/app-route-config';
import { Suspense, type ReactElement } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router';

function RouteFallback() {
  return (
    <div className="mx-auto mt-12 w-full max-w-3xl" role="status" aria-live="polite">
      <div className="bg-muted h-24 animate-pulse rounded-lg" aria-hidden="true" />
      <span className="sr-only">Carregando página…</span>
    </div>
  );
}

function withSuspense(element: ReactElement) {
  return <Suspense fallback={<RouteFallback />}>{element}</Suspense>;
}

const AppRoutes = () => (
  <BrowserRouter>
    <Routes>
      {publicRoutes.map((route) => (
        <Route key={route.path} path={route.path} element={withSuspense(route.element)} />
      ))}

      <Route element={<AppLayout />}>
        {appRoutes.map((route) => (
          <Route
            key={route.path}
            element={<RequirePermission allOf={route.allOf} anyOf={route.anyOf} access={route.access} />}
          >
            <Route path={route.path} element={withSuspense(route.element)} />
          </Route>
        ))}
      </Route>

      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  </BrowserRouter>
);

export default AppRoutes;
